import { useCallback } from 'react';

import { useCurrentUserContext } from 'contexts/currentUser';
import useLifecycle, { LIFECYCLE, Lifecycle } from 'hooks/useLifecycle';

export const useInSeasonLocalStorage = (): [
  boolean,
  (value: boolean) => void,
] => {
  const { currentUser } = useCurrentUserContext();
  const { update: updateLifecycle } = useLifecycle();
  const lifecycle = currentUser?.userSettings?.lifecycle as Lifecycle;
  const inSeasonFilterEnabled = lifecycle?.inSeasonFilterEnabled ?? true;

  const setInSeason = useCallback(
    (value: boolean) => {
      updateLifecycle(LIFECYCLE.inSeasonFilterEnabled, value);
    },
    [updateLifecycle]
  );

  return [inSeasonFilterEnabled, setInSeason];
};
